import type { ConveyedPersonAction } from "../types/involvement.js";
import type { CustomerRole } from "../types/thalamos.js";
import { personActionsPermittedByRoleOrNone } from "./personActionsPermittedByRoleOrNone.js";
import { roleOrNone } from "./roleOrNone.js";

/**
 * `personActionsPermittedByRoleOrNone` for a role, or for a guest where `role`
 * is `null`, whatever the involvement.
 *
 * Exported so a caller intersecting some other action set with what a role
 * permits narrows it exactly as `personActionsFromInvolvementKindInRole` does,
 * rather than restating what each role permits.
 */
export const personActionsPermittedByRole = (
  role: CustomerRole | null,
): readonly ConveyedPersonAction[] =>
  personActionsPermittedByRoleOrNone[roleOrNone(role)];
